const createDiagonalPattern = ({ fill, stroke }: { fill: string; stroke: string }) => {
  const canvas = document.createElement("canvas")
  canvas.width = 10
  canvas.height = 10

  const ctx = canvas.getContext("2d")!
  ctx.fillStyle = fill
  ctx.strokeStyle = stroke
  ctx.fillRect(0, 0, 10, 10)

  ctx.lineWidth = 1

  ctx.beginPath()
  ctx.moveTo(8, 0)
  ctx.lineTo(0, 8)
  ctx.stroke()

  ctx.beginPath()
  ctx.moveTo(10, 8)
  ctx.lineTo(8, 10)
  ctx.stroke()

  return ctx.createPattern(canvas, "repeat")!
}

type DatasetName =
  | "overdue"
  | "planned"
  | "completed"
  | "completedReserved"
  | "plannedReserved"
  | "available"
  | "availableReserved"
  | "availableReservedHover"
  | "availableHover"
  | "availableSelected"
  | "availableReservedSelected"
  | "booked"
  | "bookedHover"
  | "bookedEmergency"
  | "bookedEmergencyHover"

const chartColors = new Map<DatasetName, string | CanvasPattern>([
  ["completed", "#58616F"],
  ["completedReserved", createDiagonalPattern({ fill: "#58616F", stroke: "#57606E" })],
  ["overdue", "#FAE366"],
  ["planned", createDiagonalPattern({ fill: "#F0F2F3", stroke: "#57606E" })],
  ["available", "#57FDC8"],
  ["availableHover", "#90E2C2"],
  ["availableSelected", "#8BDABA"],
  ["availableReserved", createDiagonalPattern({ fill: "#57FDC8", stroke: "#57606E" })],
  ["availableReservedHover", createDiagonalPattern({ fill: "#90E2C2", stroke: "#57606E" })],
  ["availableReservedSelected", createDiagonalPattern({ fill: "#8BDABA", stroke: "#57606E" })],
  ["booked", "#F0F2F3"],
  ["bookedHover", "#DFE1E2"],
  ["bookedEmergency", createDiagonalPattern({ fill: "#F0F2F3", stroke: "#57606E" })],
  ["bookedEmergencyHover", createDiagonalPattern({ fill: "#DFE1E2", stroke: "#57606E" })],
])

export { chartColors }
